import 'picturefill';
import 'core-js/stable/array/from';
import { debounce } from 'throttle-debounce';
import imageMapResize from 'image-map-resizer';
import { scrolltoTop } from './modules/scrollto-top';
import { toggleMenu } from './modules/toggle-menu';
import { openMain } from './modules/open-main';
import { sendga } from './modules/sendga';
import MoveTo from 'moveto';
import './modules/set-css-vh';
// 関数の引き渡し
window.sendga = sendga;
window.addEventListener('load', () => {
    // トップへ戻るの初期化
    scrolltoTop('.btn-scrollto-top');
    // 可変イメージマップの初期化
    imageMapResize();
    // ページ表示
    if (_PAGE_TYPE !== 'shop') {
        openMain('.main');
    }
});
window.addEventListener('DOMContentLoaded', () => {
    const toggleBtnEl = document.querySelector('.btn-hamburger');
    if (!toggleBtnEl) {
        return;
    }
    // トグルメニューの初期化
    const menu = toggleMenu('.toggle-menu');
    menu.on('beforeOpen', () => {
        toggleBtnEl.classList.add('active');
    });
    menu.on('beforeClose', () => {
        toggleBtnEl.classList.remove('active');
    });
    // スクロールエリアのアップデート
    window.addEventListener('resize', debounce(200, () => {
        if (menu.isShow) {
            menu.updateScrollBar();
        }
    }));
    // トグルボタンクリック
    toggleBtnEl.addEventListener('click', () => menu.toggle());
    // メニュー内のリンク要素すべて
    const menuLinkEls = document.querySelectorAll('.toggle-menu a');
    Array.from(menuLinkEls).forEach((el) => {
        el.addEventListener('click', () => menu.toggle());
    });
});
/**
 * ページに対応するReactコンポーネントの読み込み
 */
window.addEventListener('DOMContentLoaded', () => {
    if (typeof _PAGE_TYPE === 'undefined') {
        return;
    }
    if (_PAGE_TYPE === 'top') {
        // 商品一覧コンポーネントの読み込み
        import('../react/sale-items');
    }
    else if (_PAGE_TYPE === 'shop') {
        // ショップ一覧コンポーネントの読み込み
        import('../react/shop-items');
    }
});
/**
 * ページ内遷移の初期化
 */
window.addEventListener('load', () => {
    const moveTo = new MoveTo();
    Array.from(document.querySelectorAll('a[href^="#"]')).forEach((el) => {
        moveTo.registerTrigger(el);
    });
});
//require('./modules/modernizr')
/*import './modules/modernizr'

declare global {
  interface Window {
    Modernizr: any
  }
}

window.Modernizr.on('webp', function (res: any) {
  console.log(res)
})*/
